"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var ExecutionEnvironment_1 = tslib_1.__importDefault(require("fbjs/lib/ExecutionEnvironment"));
var connection = ExecutionEnvironment_1.default.canUseDOM &&
    (window.navigator.connection || window.navigator.mozConnection || window.navigator.webkitConnection);
var UNKNOWN = 'unknown';
var getConnectionInfoObject = function () {
    var isConnected = !ExecutionEnvironment_1.default.canUseDOM || window.navigator.onLine;
    var result = {
        type: UNKNOWN,
        isConnected: isConnected,
        isInternetReachable: isConnected,
        details: {
            effectiveType: UNKNOWN,
        },
    };
    if (!connection) {
        return result;
    }
    result.type = connection.type || UNKNOWN;
    for (var prop in connection) {
        var value = connection[prop];
        if (typeof value !== 'function' && value != null) {
            result.details[prop] = value;
        }
    }
    return result;
};
exports.NetInfo = {
    configure: function (configuration) {
        throw Error('not yet implemented');
    },
    useNetInfo: function (configuration) {
        throw Error('For hooks use this library https://www.npmjs.com/package/@wora/detect-network');
    },
    addEventListener: function (listener) {
        var wrappedHandler = function () { return listener(getConnectionInfoObject()); };
        if (!connection) {
            if (ExecutionEnvironment_1.default.canUseDOM) {
                window.addEventListener('online', wrappedHandler, false);
                window.addEventListener('offline', wrappedHandler, false);
                return function () {
                    window.removeEventListener('online', wrappedHandler, false);
                    window.removeEventListener('offline', wrappedHandler, false);
                };
            }
        }
        else {
            connection.addEventListener('change', wrappedHandler);
            return function () { return connection.removeEventListener('change', wrappedHandler); };
        }
        return function () { return undefined; };
    },
    fetch: function (requestedInterface) {
        return Promise.resolve(getConnectionInfoObject());
    },
};
//# sourceMappingURL=NetInfo.js.map